<template>
  <UIPopup
    v-model="modelValue"
    :closeable="false"
    hide-buttons
    full-screen
    :max-width="isDesktop ? '1130px' : isTablet ? '553px' : ''"
  >
    <template #header>
      <div class="mx-auto flex max-w-[416px] flex-col items-center justify-center gap-5 desktop:mt-24">
        <UIIcon name="check-filled" class="!size-[64px] text-gold-primary-100" />
        <h1 class="text-center text-2xl text-black-100">{{ $t('payment.success.title') }}</h1>
        <span class="text-center text-base font-semibold">{{ $t('payment.success.subtitle') }}</span>
        <div v-if="packageDetails" class="mt-2 rounded-lg bg-gold-primary-10 px-4 py-3 text-center">
          <p class="text-sm font-medium text-black-100">
            {{ packageDetails }}
          </p>
        </div>
      </div>
    </template>
    <template #body>
      <div class="mx-auto max-w-[488px]">
        <p class="mb-12 text-black-80">{{ $t('payment.success.message') }}</p>
        <UIButton id="join" class="mx-auto w-full" @click="showProfilePopup">
          {{ $t('payment.success.unlockButton') }}
        </UIButton>
        <p class="mt-4">
          {{ $t('payment.success.support.question') }}
          <NuxtLink
            no-prefetch
            class="!underline"
            to="https://api.whatsapp.com/send/?phone=%2B971527033506&text=I%20want%20to%20fly%20before%20I%27ll%20buy&type=phone_number&app_absent=0"
            target="_blank"
          >
            {{ $t('payment.success.support.whatsapp') }}
            <UIIcon name="whatsapp-fill" class="ml-1" />
          </NuxtLink>
        </p>
      </div>
    </template>
  </UIPopup>
</template>

<script setup lang="ts">
import { POPUPS } from '@/components/dynamic/maps'

const gtm = useGtm()
const modelValue = defineModel<boolean>()

const uiStore = useUIStore()
const localePath = useLocalePath()

const { isTablet, isDesktop } = useAppBreakpoints()
const authStore = useAuthStore()
const { userPackage } = usePackageFeatures()

const packageDetails = computed(() => {
  if (!userPackage.value) return null

  const tier = userPackage.value.tier
    ? userPackage.value.tier.charAt(0).toUpperCase() + userPackage.value.tier.slice(1)
    : ''
  const billing = userPackage.value.billingPeriod
    ? userPackage.value.billingPeriod.charAt(0).toUpperCase() + userPackage.value.billingPeriod.slice(1)
    : ''

  if (tier && billing) {
    return `Package: ${tier} (${billing})`
  } else if (tier) {
    return `${userPackage.value.name} - ${tier}`
  }
  return userPackage.value.name
})

gtm?.trackEvent({ event: 'purchase' })

const showProfilePopup = () => {
  modelValue.value = false
  uiStore.cleanPopup()
  nextTick(() => {
    if (!authStore.user?.phoneVerified) {
      uiStore.showPopup(POPUPS.VERIFY_PHONE, { force: true })
    } else if (!authStore.user?.answeredQuestions) {
      uiStore.showPopup(POPUPS.FILL_PROFILE)
    } else if (!authStore.user?.bookedFirstCall) {
      uiStore.showPopup(POPUPS.BOOK_A_CALL)
    }
    navigateTo(localePath('/'))
  })
}
</script>
